import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import useStyles from './BaseButtonCityoo.styles';

const propTypes = {
    title: PropTypes.string.isRequired
};

const BaseButtonCityoo = ({ title, ...rest }) => {
    const classes = useStyles();

    return (
        <Button {...rest} className={classes.button}>
            {title}
        </Button>
    );
};

BaseButtonCityoo.propTypes = propTypes;

export default BaseButtonCityoo;
